// import { useState } from 'react';
import {
  CONCERT_INFO1,
  // CONCERT_INFO2,
  // CONCERT_INFO3,
  CONCERT_INFO_BACKGROUND,
} from 'src/assets/database/webData';
import { BOARD_SET_WIDTH_WEB } from 'src/consts/user-web.const';
import { FlexBox, FlexBoxFullWidth } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

export default function WebConcertInfo() {
  // const [selectedInfoId, setSelectedInfoId] = useState(1);
  // const onClickSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   const { value } = event.currentTarget;
  //   setSelectedInfoId(Number(value));
  // };
  return (
    <ContainerWebConcertInfo>
      {/* <ConcertInfoSelectBlock>
        <h1>공연 정보</h1>
        <h2>제주사람들의 희망을 기원하는 축제 정보를 확인하세요.</h2>
        <ButtonBox>
          <SelectButton1
            onClick={onClickSelect}
            value="1"
            selected={selectedInfoId === 1}
            type="button"
          >
            1일차 개막공연
          </SelectButton1>
          <SelectButton2
            onClick={onClickSelect}
            value="2"
            selected={selectedInfoId === 2}
            type="button"
          >
            2일차 주제공연
          </SelectButton2>
          <SelectButton3
            onClick={onClickSelect}
            value="3"
            selected={selectedInfoId === 3}
            type="button"
          >
            2일차 피날레 공연
          </SelectButton3>
        </ButtonBox>
      </ConcertInfoSelectBlock> */}
      <ConcertBackgroundImageBoard>
        {/* {selectedInfoId === 1 && <ConcertImageBoard src={CONCERT_INFO1} />}
        {selectedInfoId === 2 && <ConcertImageBoard src={CONCERT_INFO2} />}
        {selectedInfoId === 3 && <ConcertImageBoard src={CONCERT_INFO3} />} */}
        <ConcertImageBoard src={CONCERT_INFO1} />
      </ConcertBackgroundImageBoard>
    </ContainerWebConcertInfo>
  );
}
const ContainerWebConcertInfo = styled(FlexBox)`
  width: 100%;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
// const ConcertInfoSelectBlock = styled(FlexBox)`
//   width: 100%;
//   padding: 40px 0 44px 0;

//   background-color: #f0f1f4;

//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   > h1 {
//     color: var(--Font-02_black, #111);
//     text-align: center;
//     font-family: Cafe24Ohsquare;
//     font-size: 32px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 140%;
//     letter-spacing: -0.08px;
//     margin-bottom: 4px;
//   }
//   > h2 {
//     color: var(--Font-02_black, #111);
//     text-align: center;
//     font-size: 16px;
//     font-style: normal;
//     font-weight: 600;
//     line-height: 26px; /* 162.5% */
//     letter-spacing: -0.04px;
//     margin-bottom: 16px;
//   }
// `;
// const ButtonBox = styled(FlexBox)`
//   justify-content: center;
//   align-items: center;
//   gap: 12px;
// `;
// const SelectButton = styled.button<{ selected: boolean }>`
//   background: #fff;
//   width: 160px;
//   padding: 8px 0;
//   border-radius: 24px;
//   text-align: center;

//   font-size: 16px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: 140%;
//   letter-spacing: -0.04px;

//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;
// const SelectButton1 = styled(SelectButton)`
//   border: ${({ selected }) =>
//     selected ? '1px solid #83392E' : '1px solid #E5E5EC'};
//   color: ${({ selected }) => (selected ? '#83392E' : '#505050')};
// `;
// const SelectButton2 = styled(SelectButton)`
//   border: ${({ selected }) =>
//     selected ? '1px solid #25258C' : '1px solid #E5E5EC'};
//   color: ${({ selected }) => (selected ? '#25258C' : '#505050')};
// `;
// const SelectButton3 = styled(SelectButton)`
//   border: ${({ selected }) =>
//     selected ? '1px solid #7BAF78' : '1px solid #E5E5EC'};
//   color: ${({ selected }) => (selected ? '#206F1C' : '#505050')};
// `;
const ConcertBackgroundImageBoard = styled(FlexBoxFullWidth)`
  width: 100%;
  background-image: url(${CONCERT_INFO_BACKGROUND});
  background-size: cover;
  background-position: top;

  //원본 가로사이즈보다 이미지가 커질 시 맨 왼쪽에 약간의 흰색 여백이 생기는 오류 방지(원인 불명)
  padding: 80px 0 200px 0;

  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1600px) {
    width: 101%;
  }
`;

const ConcertImageBoard = styled.img`
  width: ${BOARD_SET_WIDTH_WEB}px;
  margin: 0 auto;
`;
